module.exports = __webpack_public_path__ + "img/li3.93d91aa3.png";